import Form from 'react-bootstrap/Form';

export const SchwabConnectionForm = ({
    values,
    onChange,
}) => (
    <>
        <Form.Group className="mb-3" controlId="schwab-client-id">
            <Form.Label><h5>Schwab App Key</h5></Form.Label>
            <Form.Control
                value={values.schwabClientId || ''}
                onChange={onChange}
                type="text"
                placeholder="Schwab App Key"
                name="schwabClientId"
                required
                autoComplete='off'
            />
        </Form.Group>
        <Form.Group className="mb-3" controlId="schwab-client-secret">
            <Form.Label><h5>Schwab Secret</h5></Form.Label>
            <Form.Control
                value={values.schwabClientSecret || ''}
                onChange={onChange}
                type="password"
                placeholder="Schwab Secret"
                name="schwabClientSecret"
                required
                autoComplete='off'
            />
        </Form.Group>
    </>
);
